import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithReAuth } from './base-query'
import type {
	CreateRentalMessageBody,
	ListRentalMessagesParams,
	ListRentalMessagesResponse,
	RentalMessage,
} from './types/rental'

// Backend contract this API is expected to satisfy — see the rental-service
// issue for RentalMessage (GET/POST /rent/:rentalId/messages, scoped via
// assertRentalInScope like RentalNote/RentalTask).
export const rentalMessagesApi = createApi({
	reducerPath: 'rentalMessagesApi',
	baseQuery: baseQueryWithReAuth,
	tagTypes: ['RentalMessage'],
	endpoints: (builder) => ({
		listRentalMessages: builder.query<ListRentalMessagesResponse, ListRentalMessagesParams>({
			query: ({ rentalId, ...params }) => ({
				url: `/rent/${rentalId}/messages`,
				params,
			}),
			providesTags: (_r, _e, { rentalId }) => [{ type: 'RentalMessage', id: rentalId }],
		}),

		sendRentalMessage: builder.mutation<RentalMessage | null, CreateRentalMessageBody>({
			query: ({ rentalId, ...body }) => ({
				url: `/rent/${rentalId}/messages`,
				method: 'POST',
				body,
			}),
			invalidatesTags: (_r, _e, { rentalId }) => [{ type: 'RentalMessage', id: rentalId }],
		}),
	}),
})

export const {
	useListRentalMessagesQuery,
	useSendRentalMessageMutation,
} = rentalMessagesApi
